<template>
  <div style="margin-top: 20px;width: 1440px;margin:0 auto;">
    <el-row>
      <!--<el-col :span="2" :offset="1">-->
       <el-col :span="5" :offset="0" class="bgnone">
        <el-collapse v-model="activeName" accordion @change="changeCollapse">
          <el-collapse-item title="加速器" name="1">
            <div id="all">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" border>Select All</el-checkbox>
            </div>
            <div style="margin: 40px 0;"></div>
            <el-checkbox-group v-model="checkedGroups" @change="handleCheckedGroupsChange">
              <div v-for="group in groupName" :key="group">
                <div :class="groupColorClassName(group)" style="width: 25px; height: 25px; margin-top: 4px; margin-right: 10px; float: left; border-radius: 50%;"></div>
                <!--<el-checkbox :label="group" style="width: 80px;" border></el-checkbox>-->
                <el-checkbox :label="group" :title="group" style="width: 224px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;" border size="small"></el-checkbox>
                <div style="margin: 10px 0; clear: both;"></div>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item title="光束线站" name="2">
            <div id="all">
              <el-checkbox :indeterminate="isIndeterminateBeamline" v-model="checkAllBeamline" @change="handleCheckAllChangeBeamline" border>Select All</el-checkbox>
            </div>
            <div style="margin: 40px 0;"></div>
            <el-checkbox-group v-model="checkedGroupsBeamline" @change="handleCheckedGroupsChangeBeamline">
              <div v-for="group in groupNameBeamline" :key="group">
                <div :class="groupColorClassNameBeamline(group)" style="width: 25px; height: 25px; margin-top: 4px; margin-right: 10px; float: left; border-radius: 50%;"></div>
                <!--<el-checkbox :label="group" style="width: 80px;" border></el-checkbox>-->
                <el-checkbox :label="group" :title="group" style="width: 224px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;" border size="small"></el-checkbox>
                <div style="margin: 10px 0; clear: both;"></div>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
        <div style="margin: 40px 0;"></div>
        <!-- <div id="all">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" border>Select All</el-checkbox>
        </div>
        <div style="margin: 20px 0;"></div>
        <el-checkbox-group v-model="checkedGroups" @change="handleCheckedGroupsChange">
          <div v-for="group in groupName" :key="group">
            <div :class="groupColorClassName(group)" style="width: 25px; height: 25px; margin-top: 4px; margin-right: 10px; float: left; border-radius: 50%;"></div>
            <el-checkbox :label="group" style="width: 80px;" border></el-checkbox>
             <el-checkbox :label="group" :title="group" style="width: 224px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;" border size="small"></el-checkbox>
            <div style="margin: 10px 0; clear: both;"></div>
          </div>
        </el-checkbox-group> -->
      </el-col>
      <el-col :span="19">
        <el-row style="margin-bottom:10px;" class="box-right">
          <el-col align="right">
            <el-checkbox class="checkboxTop" v-model="checkDisplayOK" border title="Display No-Alarm Information">Display No-Alarm Information</el-checkbox>
            <el-tag color="#67C23A">OK</el-tag>
            <el-tag color="#E6A23C">MINOR</el-tag>
            <el-tag color="#F56C6C">MAJOR</el-tag>
            <el-tag color="#ff80ff">INVALID</el-tag>
            <el-tag color="#ff80ff">UNDEFINED</el-tag>
            <el-tag color="#909399">ACK</el-tag>
          </el-col>
        </el-row>
        <el-table :data="tableData" :default-sort="{'prop': 'AlarmSeverity', 'order': 'descending'}" :row-style="tableRowStyle"
        :header-row-style="{'fontSize': '16px', 'color': 'black'}" style="width: 100%">
          <el-table-column min-width="20%" prop="PV" label="PV" :formatter="formatter" sortable :sort-method="tablePVSort"></el-table-column>
          <el-table-column min-width="15%" prop="AlarmTime" label="AlarmTime" :formatter="formatter" sortable :sort-method="tableAlarmTimeSort"></el-table-column>
          <el-table-column min-width="14%" prop="CurrentSeverity" label="CurrentSeverity" :formatter="formatter"></el-table-column>
          <el-table-column min-width="13%" prop="CurrentStatus" label="CurrentStatus" :formatter="formatter"></el-table-column>
          <el-table-column min-width="15%" prop="AlarmSeverity" label="AlarmSeverity" :formatter="formatter" sortable :sort-method="tableAlarmSeveritySort"></el-table-column>
          <el-table-column min-width="13%" prop="AlarmStatus" label="AlarmStatus" :formatter="formatter"></el-table-column>
          <el-table-column min-width="13%" prop="AlarmValue" label="Value" :formatter="formatter"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
'use strict'
// 导入websocket
import io from 'socket.io-client'
export default {
  name: 'Alarm',
  data () {
    // 注意：组件中的 data 必须是 function
    return {
      // aaa: ['AP', 'DM', 'IL', 'KLY', 'MW', 'OR', 'PS', 'TM', 'UT', 'VA'],
      colorArray: ['', 'OK', 'MINOR', 'MAJOR', 'INVALID', 'UNDEFINED', 'ACKorUnknown'],
      kafkaData: {},
      kafkaDataBeamline: {},
      // IP: 'ws://192.168.121.2:8000',
       //IP: 'ws://192.168.113.9:8000',
      // IP: 'ws://192.168.113.16:8000', 
      //IP: 'ws://192.168.113.16:8001', 
      // IPBeamLine: 'ws://192.168.113.16:8002', 
      // IP: 'ws://192.168.113.35:80',
      // IP: 'ws://' + window.location.href.split("/")[2] + ':80',
      // IPBeamLine: 'ws://' + window.location.href.split("/")[2] + ':8000',
      IP: 'ws://' + window.location.href.split("/")[2] + ':80',
      IPBeamLine: 'ws://' + window.location.href.split("/")[2] + ':80',
      title: '',
      titleBeamline: '',
      groupName: [],
      groupNameBeamline: [],
      allArray: [],
      allArrayBeamline: [],
      checkAll: true,
      checkAllBeamline:true,
      checkedGroups: [],
      checkedGroupsBeamline:[],
      isIndeterminate: true,
      isIndeterminateBeamline: true,
      checkDisplayOK: false,
      activeName: '1'
    }
  },
  computed: {
    showArray () {
      if (this.checkDisplayOK) {
        return this.allArray.filter(item => item.value).filter(item => this.checkedGroups.indexOf(item.group) !== -1)
      } else {
        return this.alarmArray.filter(item => this.checkedGroups.indexOf(item.group) !== -1)
      }
    },
    showArrayBeamline () {
      if (this.checkDisplayOK) {
        return this.allArrayBeamline.filter(item => item.value).filter(item => this.checkedGroupsBeamline.indexOf(item.group) !== -1)
      } else {
        return this.alarmArrayBeamline.filter(item => this.checkedGroupsBeamline.indexOf(item.group) !== -1)
      }
    },
    alarmArray () {
      return this.allArray.filter(item => item.value).filter(item => item.value.severity !== 'OK')
    },
    alarmArrayBeamline () {
      return this.allArrayBeamline.filter(item => item.value).filter(item => item.value.severity !== 'OK')
    },
    tableData(){
      if(this.activeName == "1"){
        return this.showArray;
      }else if(this.activeName == "2"){
        return this.showArrayBeamline;
      }
    }
  },
  watch: {
    kafkaData: {
      handler: function (newKafkaData, oldKafkaData) {
        this.allArray = []
        for (let i = 0; i < this.groupName.length; i++) {
          // 获取组对象
          let group = newKafkaData['Accelerator2025'][this.title][this.groupName[i]]
          // 组里面的PV数组
          let tempArray = Object.keys(group)
          for (let j = 0; j < tempArray.length; j++) {
            if (tempArray[j] !== 'value' && tempArray[j] !== 'name' && tempArray[j] !== 'group') {
              if (group[tempArray[j]].value) {
                this.allArray.push(group[tempArray[j]])
              }
            }
          }
        }
      },
      deep: true
    },
    kafkaDataBeamline: {
      handler: function (newKafkaData, oldKafkaData) {
        this.allArrayBeamline = []
        for (let i = 0; i < this.groupNameBeamline.length; i++) {
          // 获取组对象
          let group = newKafkaData['Beamline2025'][this.titleBeamline][this.groupNameBeamline[i]]
          // 组里面的PV数组
          let tempArray = Object.keys(group)
          for (let j = 0; j < tempArray.length; j++) {
            if (tempArray[j] !== 'value' && tempArray[j] !== 'name' && tempArray[j] !== 'group') {
              if (group[tempArray[j]].value) {
                this.allArrayBeamline.push(group[tempArray[j]])
              }
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    groupColorClassName (groupNameStr) {
      let tempCount = 0
      if (this.kafkaData && this.kafkaData['Accelerator2025'] && this.kafkaData['Accelerator2025'][this.title]) {
        let group = this.kafkaData['Accelerator2025'][this.title][groupNameStr]
        if (group) {
          let tempArray = Object.keys(group)
          for (let i = 0; i < tempArray.length; i++) {
            let name = tempArray[i]
            if (name !== 'name' && name !== 'value' && name !== 'group') {
              let pvCount = this.pvColorCount(group[tempArray[i]])
              if (pvCount > tempCount) {
                tempCount = pvCount
              }
            }
          }
        }
      }
      return this.colorArray[tempCount] + '-checkbox'
    },
    groupColorClassNameBeamline (groupNameStr) {
      let tempCount = 0
      if (this.kafkaDataBeamline && this.kafkaDataBeamline['Beamline2025'] && this.kafkaDataBeamline['Beamline2025'][this.titleBeamline]) {
        let group = this.kafkaDataBeamline['Beamline2025'][this.titleBeamline][groupNameStr]
        if (group) {
          let tempArray = Object.keys(group)
          for (let i = 0; i < tempArray.length; i++) {
            let name = tempArray[i]
            if (name !== 'name' && name !== 'value' && name !== 'group') {
              let pvCount = this.pvColorCount(group[tempArray[i]])
              if (pvCount > tempCount) {
                tempCount = pvCount
              }
            }
          }
        }
      }
      return this.colorArray[tempCount] + '-checkbox'
    },
    pvColorCount (pvObject) {
      switch (pvObject.value.severity) {
        case 'OK':case 'MINOR':case 'MAJOR':case 'INVALID':case 'UNDEFINED':
          return this.colorArray.indexOf(pvObject.value.severity)
        default:
          return 6
      }
    },
    handleCheckAllChange (val) {
      this.checkedGroups = val ? this.groupName : []
      this.isIndeterminate = false
    },
    handleCheckAllChangeBeamline (val) {
      this.checkedGroupsBeamline = val ? this.groupNameBeamline : []
      this.isIndeterminateBeamline = false
    },
    handleCheckedGroupsChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.groupName.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.groupName.length
    },
    handleCheckedGroupsChangeBeamline (value) {
      let checkedCount = value.length
      this.checkAllBeamline = checkedCount === this.groupNameBeamline.length
      this.isIndeterminateBeamline = checkedCount > 0 && checkedCount < this.groupNameBeamline.length
    },
    tableRowStyle ({row, rowIndex}) {
      let temp = {
        'fontSize': '14px',
        'color': 'black'
      }
      switch (row.value.severity) {
        case 'OK':
          temp['background-color'] = '#67C23A!important'
          break
        case 'MINOR':
          temp['background-color'] = '#E6A23C!important'
          break
        case 'MAJOR':
          temp['background-color'] = '#F56C6C!important'
          break
        case 'INVALID':case 'UNDEFINED':
          temp['background-color'] = '#FF80FF!important'
          break
        default:
          temp['background-color'] = '#909399!important'
          break
      }
      return temp
    },
    tableAlarmTimeSort (a, b) {
      let tempa = a.value.time.seconds
      let tempb = b.value.time.seconds
      if (tempa === tempb) {
        return this.tableAlarmSeveritySort(a, b)
      } else {
        return tempa - tempb
      }
    },
    tableAlarmSeveritySort (a, b) {
      let tempa = this.pvColorCount(a)
      let tempb = this.pvColorCount(b)
      if (tempa === tempb) {
        return this.tablePVSort(a, b)
      } else {
        return tempa - tempb
      }
    },
    tablePVSort (a, b) {
      if (a.name > b.name) {
        return 1
      } else {
        return -1
      }
    },
    formatter (row, column) {
      switch (column.property) {
        case 'PV':
          return row.name
        case 'AlarmTime':
          return this.$options.filters['dateFormat'](row.value.time.seconds * 1000)
        case 'CurrentSeverity':
          return row.value.current_severity
        case 'CurrentStatus':
          return row.value.current_message
        case 'AlarmSeverity':
          return row.value.severity
        case 'AlarmStatus':
          return row.value.message
        case 'AlarmValue':
          return row.value.value
        default:
          return '数据中未定义的列'
      }
    },
    processKafkaWelcomeData (data) {
      data = JSON.parse(data)
      this.kafkaData = data
      let tempArray = Object.keys(data['Accelerator2025'])
      for (let i = 0; i < tempArray.length; i++) {
        if (tempArray[i] !== 'value' && tempArray[i] !== 'name' && tempArray[i] !== 'group') {
          this.title = tempArray[i]
        }
      }
      tempArray = Object.keys(this.kafkaData['Accelerator2025'][this.title])
      this.groupName = tempArray.filter(item => item !== 'value' && item !== 'name' && item !== 'group')
      this.groupName = this.groupName.sort()
      // 初始化一下复选框
      this.handleCheckAllChange(this.checkAll)
    },
    processKafkaBroadcastData (data) {
      data = JSON.parse(data)
      let value = JSON.parse(data.value)
      let key = data.key
      let keyList = key.split('/')
      let temp = this.kafkaData
      // 从下标1开始因为下标0是空串
      for (let i = 1; i < keyList.length; i++) {
        // null的时候不会为true
        if (temp[keyList[i]] === undefined) {
          temp[keyList[i]] = {}
        }
        if (i !== keyList.length - 1) {
          temp = temp[keyList[i]]
        } else {
          if (value === null) {
            delete temp[keyList[i]]
          } else {
            temp[keyList[i]].name = keyList[i]
            temp[keyList[i]].group = keyList[i - 1]
            temp[keyList[i]].value = value
          }
        }
      }
    },
    processKafkaWelcomeDataBeamLine (data) {
      data = JSON.parse(data)
      this.kafkaDataBeamline = data
      let tempArray = Object.keys(data['Beamline2025'])
      for (let i = 0; i < tempArray.length; i++) {
        if (tempArray[i] !== 'value' && tempArray[i] !== 'name' && tempArray[i] !== 'group') {
          this.titleBeamline = tempArray[i]
        }
      }
      tempArray = Object.keys(this.kafkaDataBeamline['Beamline2025'][this.titleBeamline])
      this.groupNameBeamline = tempArray.filter(item => item !== 'value' && item !== 'name' && item !== 'group')
      this.groupNameBeamline = this.groupNameBeamline.sort()
      // 初始化一下复选框
      this.handleCheckAllChangeBeamline(this.checkAllBeamline)
    },
    processKafkaBroadcastDataBeamLine (data) {
      data = JSON.parse(data)
      let value = JSON.parse(data.value)
      let key = data.key
      let keyList = key.split('/')
      let temp = this.kafkaDataBeamline
      // 从下标1开始因为下标0是空串
      for (let i = 1; i < keyList.length; i++) {
        // null的时候不会为true
        if (temp[keyList[i]] === undefined) {
          temp[keyList[i]] = {}
        }
        if (i !== keyList.length - 1) {
          temp = temp[keyList[i]]
        } else {
          if (value === null) {
            delete temp[keyList[i]]
          } else {
            temp[keyList[i]].name = keyList[i]
            temp[keyList[i]].group = keyList[i - 1]
            temp[keyList[i]].value = value
          }
        }
      }
    },
    changeCollapse(val){
    }
  },
  filters: {
    dateFormat: function (dateStr, pattern = '') {
      // 根据给定的时间字符串，得到特定的时间
      let dt = new Date(dateStr)
      //   yyyy-mm-dd
      let y = dt.getFullYear()
      let m = (dt.getMonth() + 1).toString().padStart(2, '0')
      let d = dt.getDate().toString().padStart(2, '0')
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`
      } else {
        let hh = dt.getHours().toString().padStart(2, '0')
        let mm = dt.getMinutes().toString().padStart(2, '0')
        let ss = dt.getSeconds().toString().padStart(2, '0')
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
      }
    }
  },
  created () {
    let that = this
    // const client = io(that.IP)
    const client = io(that.IP,{path:'/socket.io1'})
    client.on('welcome', function (data) {
      // data是一个JSON字符串
      that.processKafkaWelcomeData(data)
    })
    client.on('connect', function () {
      console.log('connect')
    })
    client.on('broadcast', function (data) {
      // data是一个JSON字符串
      that.processKafkaBroadcastData(data)
      // that.tableData = that.showArray;
    })
    client.on('error', function (err) {
      console.log(err)
    })
    // const clientBeamLine = io(that.IPBeamLine)
    const clientBeamLine = io(that.IPBeamLine,{path:'/socket.io2'})
    clientBeamLine.on('welcome', function (data) {
      // data是一个JSON字符串
      that.processKafkaWelcomeDataBeamLine(data)
    })
    clientBeamLine.on('connect', function () {
      console.log('connectBeamLine')
    })
    clientBeamLine.on('broadcast', function (data) {
      // data是一个JSON字符串
      that.processKafkaBroadcastDataBeamLine(data)
    })
    clientBeamLine.on('error', function (err) {
      console.log(err)
    })
  }
}
</script>

<style scoped>
  .el-tag {
    font-size: 18px;
    color: #ffffff;
  }
  .OK-checkbox {
    background: #67C23A;
    color: white;
  }
  .MINOR-checkbox {
    background: #E6A23C;
    color: white;
  }
  .MAJOR-checkbox {
    background: #F56C6C;
    color: white;
  }
  .INVALID-checkbox {
    background: #ff80ff;
    color: white;
  }
  .UNDEFINED-checkbox {
    background: #ff80ff;
    color: white;
  }
  .ACKorUnknown-checkbox {
    background: #909399;
    color: white;
  }
  #all .el-checkbox__label {
    font-size: 18px;
  }
  /deep/.el-checkbox .el-checkbox__label {
    width: 174px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
   /deep/.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label{
  }
  /deep/.checkboxTop .el-checkbox__input{margin-top: -8px}
  /deep/.bgnone .el-collapse .el-collapse-item__header{
    background-color:rgba(255,255,255,0);
    font-size: 16px;
  }
  /deep/.bgnone .el-collapse .el-collapse-item__wrap{
    background-color:rgba(255,255,255,0);
  }
  .box-right /deep/ .el-checkbox .el-checkbox__label {
    width: 206px!important;
}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/Alarm.vue